import React, { Dispatch, SetStateAction, useEffect, useState } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';

import { UseOutletContextProviderInvoice } from './ProviderInvoice';
import { StateLanguage } from '../../../../languages/config/StateLanguage';
import { ProviderInvoiceDA } from '../../../../services/admin/provider.invoice.service';
import { PaymentDA } from '../../../../services/admin/payment.service';
import { GlobalSwal } from '../../../../styles/swal.style';
import { Error } from '../../../../models/error.model';
import { ProviderInvoice } from '../../../../models/provider.invoice.model';
import { modalShow } from '../../../../utils/modal.util';
import { formatMoney } from '../../../../scripts/format.value.script';
import { dateFormat } from '../../../../scripts/date.time.format.script';
import { colorStatusProviderInvoice } from '../../../../scripts/badge.color.script';
import { treasuryAccountSelected } from '../../../../scripts/list.selected.script';
import { paymentMethodValue } from '../../../../libraries/payment.library';
import { getError } from '../../../../languages/translations/response';
import { normalizeStatus, statusDocumentValue } from '../../../../libraries/status.document.library';
import { errorWebHandler } from '../../../../scripts/error.web.handler.script';
import { MediaDA } from '../../../../services/admin/media.service';

import AppModalPaymentCreateProviderInvoice from '../../../../components/modal/ModalPaymentCreateProviderInvoice';
import AppPurchaseViewDetail from '../component/PurchaseViewDetail';
import AppPurchaseViewRequirements from '../component/PurchaseViewRequirements';
import AppPurchaseViewAmount from '../component/PurchaseViewAmount';
import AppPurchaseViewSignatures from '../component/PurchaseViewSignatures';
import AppPurchaseViewVouchers from '../component/PurchaseViewVouchers';
import AppPreloader from '../../../../components/Preloader';
import AppModalSendEmail from '../../../../components/modal/ModalSendEmail';
import AppModalProviderInvoiceUpdateValidate from '../../../../components/modal/ModalProviderInvoiceUpdateStatusValidate';
import AppModalProviderInvoiceUpdateInvalidate from '../../../../components/modal/ModalProviderInvoiceUpdateStatusInvalidate';
import AppPurchaseViewDraft from '../component/PurchaseViewDraft';
import AppModalProviderInvoiceStorageCenter from '../../../../components/modal/ModalProviderInvoiceStorageCenter';
import DocumentNavigation from '../../../../components/element/DocumentNavigation';
export interface ProviderInvoiceViewPageProps {};

let errorResponse: Error, providerInvoiceResponse: ProviderInvoice, paymentResponse: ProviderInvoice;

const ProviderInvoiceViewPage: React.FunctionComponent<ProviderInvoiceViewPageProps> = props => {
  const {asideMinimize, setAsideMinimize, setRoute, companyForUser, settingsForCompany, accountingAccountsForCompany, accountingDebitEntriesForCompany, treasuryAccountsForCompany, storageCentersForCompany, accountingTaxAccountsForCompany, accountingExpenseAccountsForCompany, loadAccountingDebitEntriesForCompany} = UseOutletContextProviderInvoice()
  const {lang} = StateLanguage()
  const param = useParams()
  const navigate = useNavigate()

  const [mounted, setMounted] = useState(false)
  const [removePayment, setRemovePayment] = useState(false)
  const [providerInvoice, setProviderInvoice] = useState<ProviderInvoice | null>(null)
  const setProviderInvoiceNormalized: Dispatch<SetStateAction<ProviderInvoice | null>> = (value) => {
    setProviderInvoice((prev) => {
      const next = typeof value === 'function' ? (value as (p: ProviderInvoice | null) => ProviderInvoice | null)(prev) : value
      if (!next) return next
      return {
        ...next,
        status: normalizeStatus(next.status),
        ...(next.payment_status ? { payment_status: normalizeStatus(next.payment_status) } : {}),
      }
    })
  }
  const [vouchers, setVouchers] = useState({list: true, value: [] as {name: string, size: number, type: string, view: string, file: any}[], valid: [] as {name: boolean, file: boolean}[]})

  const loadProviderInvoice = async (id_company: string, id_provider_invoice: string) => {
    await ProviderInvoiceDA.getProviderInvoice(id_company, id_provider_invoice).then( async (response) => {
      if (response.status === 200) {
        providerInvoiceResponse = response.data
        providerInvoiceResponse.status = normalizeStatus(providerInvoiceResponse.status)
        if (providerInvoiceResponse.payment_status) providerInvoiceResponse.payment_status = normalizeStatus(providerInvoiceResponse.payment_status)

        let tempVouchersValue: {name: string, size: number, type: string, view: string, file: any}[] = []
        let tempVouchersValid: {name: boolean, file: boolean}[] = []

        for (let voucher of (providerInvoiceResponse.vouchers ?? [])) {
          const vName = voucher.original_name ?? voucher.name ?? ''
          const vType = voucher.content_type ?? 'application/pdf'
          let vView = ''

          if (voucher.id_document_inbox && companyForUser) {
            const signedUrl = await MediaDA.getDocumentSignedUrl(companyForUser.id, voucher.id_document_inbox)
            if (signedUrl) vView = signedUrl
          } else if (voucher.file) {
            vView = voucher.file
          }

          tempVouchersValue.push({
            name: vName,
            size: voucher.size ?? 0,
            type: vType,
            view: vView,
            file: vView
          })
          tempVouchersValid.push({ name: !!vName, file: !!vView })
        }

        setVouchers({list: true, value: tempVouchersValue, valid: tempVouchersValid})
        setProviderInvoice(providerInvoiceResponse)
      } else {
        errorResponse = response.data

        GlobalSwal.fire({
          title: getError(errorResponse.code, lang.code, errorResponse.message),
          text: lang.labels.sorryLooksLikeThereAreSomeErrorstryAgain,
          icon: 'error',
          confirmButtonText: lang.labels.okGotIt
        })
      }
    }).catch( (error) => {
      errorWebHandler(lang, error)
    }) 
  }

  const submitPaymentDelete = async (item: string) => {
    if (companyForUser && providerInvoice) {
      GlobalSwal.fire({
        title: lang.labels.youWantToDeleteThisPayment,
        text: lang.labels.youWillNotBeAbleToUndo,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: lang.labels.yesDelete,
        cancelButtonText: lang.labels.noCancel
      }).then(async (result) => {
        if (result.isConfirmed) {
          let companyData = {subject_tax: settingsForCompany?.subject_tax ?? companyForUser?.subject_tax ?? false, tax_method: settingsForCompany?.tax_method ?? companyForUser?.tax_method ?? 'effective', tax_declaration: settingsForCompany?.tax_declaration ?? companyForUser?.tax_declaration ?? 'invoicing', tax_period: settingsForCompany?.tax_period ?? companyForUser?.tax_period ?? '', tax_statement: settingsForCompany?.tax_statement ?? companyForUser?.tax_statement ?? '', language: settingsForCompany?.language ?? companyForUser?.language ?? 'FR'}

          await PaymentDA.deletePaymentProviderInvoice(companyForUser.id, providerInvoice.id, item, companyData).then( (response) => {
            if (response.status === 200) {
              paymentResponse = response.data
              paymentResponse.status = normalizeStatus(paymentResponse.status)
              if (paymentResponse.payment_status) paymentResponse.payment_status = normalizeStatus(paymentResponse.payment_status)

              setProviderInvoice(paymentResponse)
              loadAccountingDebitEntriesForCompany(companyForUser.id)

              GlobalSwal.fire({
                title: lang.labels.successfullyDeletedPayment,
                text: lang.labels.actionCompletedReturningToPage,
                icon: 'success',
                showConfirmButton: false,
                timer: 2200
              })
            } else {
              errorResponse = response.data

              GlobalSwal.fire({
                title: getError(errorResponse.code, lang.code, errorResponse.message),
                text: lang.labels.sorryLooksLikeThereAreSomeErrorstryAgain,
                icon: 'error',
                confirmButtonText: lang.labels.okGotIt
              })
            }
          }).catch( (error) => {
            errorWebHandler(lang, error)
          })
        }
      })
    }
  }

  const excuteViewOrHideButtonsToPaymentDelete = () => {
    setRemovePayment(!removePayment)
  }

  const submitProviderInvoiceRevertToDraft = async () => {
    if (companyForUser && providerInvoice) {
      GlobalSwal.fire({
        title: lang.labels.youWantToRevertThisDocumentToDraft,
        text: lang.labels.youWillNotBeAbleToUndo,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: lang.labels.yesConfirm,
        cancelButtonText: lang.labels.noCancel
      }).then(async (result) => {
        if (result.isConfirmed) {
          await ProviderInvoiceDA.revertToDraft(companyForUser.id, providerInvoice.id).then((response) => {
            if (response.status === 200) {
              const updated = response.data
              updated.status = normalizeStatus(updated.status)
              if (updated.payment_status) updated.payment_status = normalizeStatus(updated.payment_status)
              setProviderInvoice(updated)

              GlobalSwal.fire({
                title: lang.labels.successfullyUpdated,
                text: lang.labels.actionCompletedReturningToPage,
                icon: 'success',
                showConfirmButton: false,
                timer: 2200
              })
            } else {
              errorResponse = response.data

              GlobalSwal.fire({
                title: getError(errorResponse.code, lang.code, errorResponse.message),
                text: lang.labels.sorryLooksLikeThereAreSomeErrorstryAgain,
                icon: 'error',
                confirmButtonText: lang.labels.okGotIt
              })
            }
          }).catch((error) => {
            errorWebHandler(lang, error)
          })
        }
      })
    }
  }

  const submitProviderInvoiceDelete = async () => {
    if (companyForUser && providerInvoice) {
      GlobalSwal.fire({
        title: lang.labels.youWantToDeleteThisDocument,
        text: lang.labels.youWillNotBeAbleToUndo,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: lang.labels.yesDelete,
        cancelButtonText: lang.labels.noCancel
      }).then(async (result) => {
        if (result.isConfirmed) {
          await ProviderInvoiceDA.deleteProviderInvoice(companyForUser.id, providerInvoice.id).then((response) => {
            if (response.status === 200) {
              GlobalSwal.fire({
                title: lang.labels.successfullyDeletedDocument,
                text: lang.labels.actionCompletedReturningToPage,
                icon: 'success',
                showConfirmButton: false,
                timer: 2200
              }).then(() => {
                navigate('/main/purchase/invoice/list', {replace: true})
              })
            } else {
              errorResponse = response.data

              GlobalSwal.fire({
                title: getError(errorResponse.code, lang.code, errorResponse.message),
                text: lang.labels.sorryLooksLikeThereAreSomeErrorstryAgain,
                icon: 'error',
                confirmButtonText: lang.labels.okGotIt
              })
            }
          }).catch((error) => {
            errorWebHandler(lang, error)
          })
        }
      })
    }
  }

  const handleAcceptInvoice = async () => {
    if (!companyForUser || !providerInvoice) return

    GlobalSwal.fire({
      title: lang.labels.acceptInvoice,
      text: lang.labels.confirmAcceptInvoice,
      icon: 'question',
      showCancelButton: true,
      confirmButtonText: lang.labels.acceptInvoice,
      cancelButtonText: lang.labels.cancel,
    }).then(async (result) => {
      if (result.isConfirmed) {
        await ProviderInvoiceDA.acceptProviderInvoice(companyForUser.id, providerInvoice.id).then( (response) => {
          if (response.status === 200 || response.status === 201) {
            GlobalSwal.fire({
              title: lang.labels.providerInvoiceAccepted,
              text: lang.labels.actionCompletedReturningToPage,
              icon: 'success',
              showConfirmButton: false,
              timer: 2200
            }).then( () => {
              loadProviderInvoice(companyForUser.id, providerInvoice.id)
            })
          } else {
            errorResponse = response.data

            GlobalSwal.fire({
              title: getError(errorResponse.code, lang.code, errorResponse.message),
              text: lang.labels.sorryLooksLikeThereAreSomeErrorstryAgain,
              icon: 'error',
              confirmButtonText: lang.labels.okGotIt
            })
          }
        }).catch( (error) => {
          errorWebHandler(lang, error)
        })
      }
    })
  }

  const handleDeclineInvoice = async () => {
    if (!companyForUser || !providerInvoice) return

    GlobalSwal.fire({
      title: lang.labels.declineInvoice,
      text: lang.labels.confirmDeclineInvoice,
      icon: 'warning',
      input: 'textarea',
      inputLabel: lang.labels.declineReasonLabel,
      inputPlaceholder: lang.labels.declineInvoiceReasonPlaceholder,
      inputValidator: (value) => {
        if (!value || !value.trim()) {
          return lang.labels.declineReasonRequired
        }
      },
      showCancelButton: true,
      confirmButtonText: lang.labels.declineInvoice,
      cancelButtonText: lang.labels.cancel,
    }).then(async (result) => {
      if (result.isConfirmed) {
        await ProviderInvoiceDA.declineProviderInvoice(companyForUser.id, providerInvoice.id, result.value).then( (response) => {
          if (response.status === 200) {
            GlobalSwal.fire({
              title: lang.labels.providerInvoiceDeclined,
              text: lang.labels.actionCompletedReturningToPage,
              icon: 'success',
              showConfirmButton: false,
              timer: 2200
            }).then( () => {
              loadProviderInvoice(companyForUser.id, providerInvoice.id)
            })
          } else {
            errorResponse = response.data

            GlobalSwal.fire({
              title: getError(errorResponse.code, lang.code, errorResponse.message),
              text: lang.labels.sorryLooksLikeThereAreSomeErrorstryAgain,
              icon: 'error',
              confirmButtonText: lang.labels.okGotIt
            })
          }
        }).catch( (error) => {
          errorWebHandler(lang, error)
        })
      }
    })
  }

  const executeShowModalPaymentCreateProviderInvoice = () => {
    modalShow('modal-payment-create-provider-invoice')
  }

  const executeShowModalProviderInvoiceUpdateValidateInvalidate = () => {
    if (providerInvoice) {
      modalShow(`modal-provider-invoice-update-${(providerInvoice.validated) ? "in" : ""}validate`)
    }
  }

  const executeShowModalSendEmail = () => {
    modalShow('modal-send-email')
  }

  const executeShowModalCorrectAccounts = () => {
    modalShow('modal-provider-invoice-correct-accounts')
  }

  const executeShowModalInvoiceStorageCenter = () => {
    modalShow('modal-provider-invoice-storage-center')
  }

  useEffect( () => {
    if (companyForUser && param.id) {
      loadProviderInvoice(companyForUser.id, param.id)
    }

  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [companyForUser, param])

  useEffect( () => {
    setMounted(true)
    setRoute({path: {root: lang.labels.providerInvoices, branch: lang.labels.viewProviderInvoice}, company: false})

    return () => setMounted(false)

  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  if (!mounted) return null

  return (
    <div className="w-100 h-100">
      { companyForUser && treasuryAccountsForCompany && storageCentersForCompany && providerInvoice
        ?
        <div className="d-flex flex-column flex-lg-row">
          <div className="flex-lg-row-fluid order-2 order-lg-1 mb-5 mb-lg-0 me-lg-5">
            <div className="card card-flush mb-5">
              <div className="card-header pt-3">
                <div className="card-title align-items-start flex-column">
                  <div className="d-flex align-items-center gap-3">
                    <h1 className="mb-0">{providerInvoice.provider_invoice_number}</h1>
                    {companyForUser && param.id && <DocumentNavigation navKey="nav_provider_invoices" currentId={param.id} companyId={companyForUser.id} basePath="/main/purchase/invoice/view/" />}
                  </div>
                  <label className="fs-6 fw-bold mt-1">
                    {lang.labels.status}:
                    <span className={`badge badge-light-${colorStatusProviderInvoice(providerInvoice.status)} text-uppercase fs-7 ms-2`}>{statusDocumentValue(lang, providerInvoice.status)}</span>
                  </label>
                </div>
                <div className="card-toolbar">
                  { providerInvoice.acceptance_status === 'pending' &&
                    <>
                      <button className="btn btn-success mb-1 me-2" type="button" onClick={handleAcceptInvoice}>
                        <div className="d-flex align-items-center">
                          <span className="svg-icon svg-icon-2 ms-0">
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path opacity="0.3" d="M10.3 14.3L11 13.6L7.70002 10.3C7.30002 9.9 6.7 9.9 6.3 10.3C5.9 10.7 5.9 11.3 6.3 11.7L10.3 15.7C9.9 15.3 9.9 14.7 10.3 14.3Z" fill="black"/>
                              <path d="M22 12C22 17.5 17.5 22 12 22C6.5 22 2 17.5 2 12C2 6.5 6.5 2 12 2C17.5 2 22 6.5 22 12ZM11.7 15.7L17.7 9.70001C18.1 9.30001 18.1 8.69999 17.7 8.29999C17.3 7.89999 16.7 7.89999 16.3 8.29999L11 13.6L7.70001 10.3C7.30001 9.89999 6.69999 9.89999 6.29999 10.3C5.89999 10.7 5.89999 11.3 6.29999 11.7L10.3 15.7C10.5 15.9 10.8 16 11 16C11.2 16 11.5 15.9 11.7 15.7Z" fill="black"/>
                            </svg>
                          </span>
                          {lang.labels.acceptInvoice}
                        </div>
                      </button>
                      <button className="btn btn-danger mb-1 me-2" type="button" onClick={handleDeclineInvoice}>
                        <div className="d-flex align-items-center">
                          <span className="svg-icon svg-icon-2 ms-0">
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path opacity="0.3" d="M12 10.6L14.8 7.8C15.2 7.4 15.8 7.4 16.2 7.8C16.6 8.2 16.6 8.80002 16.2 9.20002L13.4 12L12 10.6ZM10.6 12L7.8 14.8C7.4 15.2 7.4 15.8 7.8 16.2C8 16.4 8.3 16.5 8.5 16.5C8.7 16.5 8.99999 16.4 9.19999 16.2L12 13.4L10.6 12Z" fill="black"/>
                              <path d="M22 12C22 17.5 17.5 22 12 22C6.5 22 2 17.5 2 12C2 6.5 6.5 2 12 2C17.5 2 22 6.5 22 12ZM13.4 12L16.2 9.20001C16.6 8.80001 16.6 8.19999 16.2 7.79999C15.8 7.39999 15.2 7.39999 14.8 7.79999L12 10.6L9.2 7.79999C8.8 7.39999 8.2 7.39999 7.8 7.79999C7.4 8.19999 7.4 8.80001 7.8 9.20001L10.6 12L7.8 14.8C7.4 15.2 7.4 15.8 7.8 16.2C8 16.4 8.3 16.5 8.5 16.5C8.7 16.5 9 16.4 9.2 16.2L12 13.4L14.8 16.2C15 16.4 15.3 16.5 15.5 16.5C15.7 16.5 16 16.4 16.2 16.2C16.6 15.8 16.6 15.2 16.2 14.8L13.4 12Z" fill="black"/>
                            </svg>
                          </span>
                          {lang.labels.declineInvoice}
                        </div>
                      </button>
                    </>
                  }
                  { storageCentersForCompany.length > 0 && providerInvoice.requirements.some((item) => (item.type === 'product' && item.contents.some(sub_item => (sub_item.reference ?? '').length > 0))) && !(providerInvoice.stock_status === 'done' || (!providerInvoice.stock_status && providerInvoice.inventoried)) &&
                    <button className="btn btn-light-primary mb-1 me-2" type="button" onClick={executeShowModalInvoiceStorageCenter}>
                      <div className="d-flex align-items-center">
                        <span className="svg-icon svg-icon-2 ms-0">
                          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path opacity="0.3" d="M3 13H10C10.6 13 11 13.4 11 14V21C11 21.6 10.6 22 10 22H3C2.4 22 2 21.6 2 21V14C2 13.4 2.4 13 3 13Z" fill="black"/>
                            <path d="M7 16H6C5.4 16 5 15.6 5 15V13H8V15C8 15.6 7.6 16 7 16Z" fill="black"/>
                            <path opacity="0.3" d="M14 13H21C21.6 13 22 13.4 22 14V21C22 21.6 21.6 22 21 22H14C13.4 22 13 21.6 13 21V14C13 13.4 13.4 13 14 13Z" fill="black"/>
                            <path d="M18 16H17C16.4 16 16 15.6 16 15V13H19V15C19 15.6 18.6 16 18 16Z" fill="black"/>
                            <path opacity="0.3" d="M3 2H10C10.6 2 11 2.4 11 3V10C11 10.6 10.6 11 10 11H3C2.4 11 2 10.6 2 10V3C2 2.4 2.4 2 3 2Z" fill="black"/>
                            <path d="M7 5H6C5.4 5 5 4.6 5 4V2H8V4C8 4.6 7.6 5 7 5Z" fill="black"/>
                            <path opacity="0.3" d="M14 2H21C21.6 2 22 2.4 22 3V10C22 10.6 21.6 11 21 11H14C13.4 11 13 10.6 13 10V3C13 2.4 13.4 2 14 2Z" fill="black"/>
                            <path d="M18 5H17C16.4 5 16 4.6 16 4V2H19V4C19 4.6 18.6 5 18 5Z" fill="black"/>
                          </svg>
                        </span>
                        {lang.labels.addInventory}
                      </div>
                    </button>
                  }
                  { providerInvoice.payment_status !== "fully-paid" &&
                    <button className="btn btn-primary mb-1 me-2" type="button" onClick={executeShowModalProviderInvoiceUpdateValidateInvalidate}>
                      <div className="d-flex align-items-center">
                        <span className="svg-icon svg-icon-2 ms-0">
                          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                            <path d="M17.5 11H6.5C4 11 2 9 2 6.5C2 4 4 2 6.5 2H17.5C20 2 22 4 22 6.5C22 9 20 11 17.5 11ZM15 6.5C15 7.9 16.1 9 17.5 9C18.9 9 20 7.9 20 6.5C20 5.1 18.9 4 17.5 4C16.1 4 15 5.1 15 6.5Z" fill="black"></path>
                            <path opacity="0.3" d="M17.5 22H6.5C4 22 2 20 2 17.5C2 15 4 13 6.5 13H17.5C20 13 22 15 22 17.5C22 20 20 22 17.5 22ZM4 17.5C4 18.9 5.1 20 6.5 20C7.9 20 9 18.9 9 17.5C9 16.1 7.9 15 6.5 15C5.1 15 4 16.1 4 17.5Z" fill="black"></path>
                          </svg>
                        </span>
                        {providerInvoice.validated ? lang.labels.invalidate : lang.labels.validate}
                      </div>
                    </button>
                  }
                  { providerInvoice.validated &&
                    <button className="btn btn-light-primary mb-1 me-2" type="button" onClick={executeShowModalCorrectAccounts}>
                      <div className="d-flex align-items-center">
                        <span className="svg-icon svg-icon-2 ms-0">
                          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path opacity="0.3" d="M2 4.63158C2 3.1782 3.1782 2 4.63158 2H13.47C14.0155 2 14.278 2.66919 13.8778 3.04006L12.4556 4.35821C11.9009 4.87228 11.1726 5.15789 10.4163 5.15789H7.1579C6.05333 5.15789 5.15789 6.05333 5.15789 7.1579V16.8421C5.15789 17.9467 6.05333 18.8421 7.1579 18.8421H16.8421C17.9467 18.8421 18.8421 17.9467 18.8421 16.8421V13.7518C18.8421 12.927 19.1817 12.1387 19.7809 11.572L20.9878 10.4308C21.3703 10.0691 22 10.3403 22 10.8668V19.3684C22 20.8218 20.8218 22 19.3684 22H4.63158C3.1782 22 2 20.8218 2 19.3684V4.63158Z" fill="black"/>
                            <path d="M10.9256 11.1882C10.5351 10.7977 10.5351 10.1645 10.9256 9.77397L18.0669 2.6327C18.8479 1.85165 20.1143 1.85165 20.8953 2.6327L21.3665 3.10391C22.1476 3.88496 22.1476 5.15129 21.3665 5.93234L14.2252 13.0736C13.8347 13.4641 13.2016 13.4641 12.811 13.0736L10.9256 11.1882Z" fill="black"/>
                            <path d="M8.82343 12.0064L8.08852 14.3348C7.8655 15.0414 8.46151 15.7366 9.19388 15.6242L11.8974 15.2092C12.4642 15.1222 12.6916 14.4278 12.2861 14.0223L9.98595 11.7221C9.61452 11.3507 8.98154 11.5055 8.82343 12.0064Z" fill="black"/>
                          </svg>
                        </span>
                        {lang.labels.correctAccounts}
                      </div>
                    </button>
                  }
                  { !providerInvoice.validated &&
                    <Link to={"/main/purchase/invoice/update/" + providerInvoice.id} className="btn btn-primary mb-1 me-2">
                      <div className="d-flex align-items-center">
                        <span className="svg-icon svg-icon-2 ms-0">
                          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path opacity="0.3" d="M2 4.63158C2 3.1782 3.1782 2 4.63158 2H13.47C14.0155 2 14.278 2.66919 13.8778 3.04006L12.4556 4.35821C11.9009 4.87228 11.1726 5.15789 10.4163 5.15789H7.1579C6.05333 5.15789 5.15789 6.05333 5.15789 7.1579V16.8421C5.15789 17.9467 6.05333 18.8421 7.1579 18.8421H16.8421C17.9467 18.8421 18.8421 17.9467 18.8421 16.8421V13.7518C18.8421 12.927 19.1817 12.1387 19.7809 11.572L20.9878 10.4308C21.3703 10.0691 22 10.3403 22 10.8668V19.3684C22 20.8218 20.8218 22 19.3684 22H4.63158C3.1782 22 2 20.8218 2 19.3684V4.63158Z" fill="black"/>
                            <path d="M10.9256 11.1882C10.5351 10.7977 10.5351 10.1645 10.9256 9.77397L18.0669 2.6327C18.8479 1.85165 20.1143 1.85165 20.8953 2.6327L21.3665 3.10391C22.1476 3.88496 22.1476 5.15129 21.3665 5.93234L14.2252 13.0736C13.8347 13.4641 13.2016 13.4641 12.811 13.0736L10.9256 11.1882Z" fill="black"/>
                            <path d="M8.82343 12.0064L8.08852 14.3348C7.8655 15.0414 8.46151 15.7366 9.19388 15.6242L11.8974 15.2092C12.4642 15.1222 12.6916 14.4278 12.2861 14.0223L9.98595 11.7221C9.61452 11.3507 8.98154 11.5055 8.82343 12.0064Z" fill="black"/>
                          </svg>
                        </span>
                        {lang.labels.edit}
                      </div>
                    </Link>
                  }
                  <button className="btn btn-primary mb-1 me-2" type="button" onClick={executeShowModalSendEmail}>
                    <div className="d-flex align-items-center">
                      <span className="svg-icon svg-icon-2 ms-0">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M15.43 8.56949L10.744 15.1395C10.6422 15.282 10.5804 15.4492 10.5651 15.6236C10.5498 15.7981 10.5815 15.9734 10.657 16.1315L13.194 21.4425C13.2737 21.6097 13.3991 21.751 13.5557 21.8499C13.7123 21.9488 13.8938 22.0014 14.079 22.0015H14.117C14.3087 21.9941 14.4941 21.9307 14.6502 21.8191C14.8062 21.7075 14.9261 21.5526 14.995 21.3735L21.933 3.33649C22.0011 3.15918 22.0164 2.96594 21.977 2.78013C21.9376 2.59432 21.8452 2.4239 21.711 2.28949L15.43 8.56949Z" fill="black"/>
                          <path opacity="0.3" d="M20.664 2.06648L2.62602 9.00148C2.44768 9.07085 2.29348 9.19082 2.1824 9.34663C2.07131 9.50244 2.00818 9.68731 2.00074 9.87853C1.99331 10.0697 2.04189 10.259 2.14054 10.4229C2.23919 10.5869 2.38359 10.7185 2.55601 10.8015L7.86601 13.3365C8.02383 13.4126 8.19925 13.4448 8.37382 13.4297C8.54839 13.4145 8.71565 13.3526 8.85801 13.2505L15.43 8.56548L21.711 2.28448C21.5762 2.15096 21.4055 2.05932 21.2198 2.02064C21.034 1.98196 20.8409 1.99788 20.664 2.06648Z" fill="black"/>
                        </svg>
                      </span>
                      {lang.labels.sendByEmail}
                    </div>
                  </button>
                  <Link to={"/main/purchase/invoice/create/reference/" + providerInvoice.id} className="btn btn-primary mb-1 me-2">
                    <div className="d-flex align-items-center">
                      <span className="svg-icon svg-icon-2 ms-0">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <rect opacity="0.5" x="7" y="2" width="14" height="16" rx="3" fill="black"/>
                          <rect x="3" y="6" width="14" height="16" rx="3" fill="black"/>
                        </svg>
                      </span>
                      {lang.labels.makeCopy}
                    </div>
                  </Link>
                  { !providerInvoice.validated && providerInvoice.status === 'in-progress' &&
                    <button className="btn btn-light-warning mb-1 me-2" type="button" onClick={submitProviderInvoiceRevertToDraft}>
                      <div className="d-flex align-items-center">
                        <span className="svg-icon svg-icon-2 ms-0">
                          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path opacity="0.3" d="M21 22H3C2.4 22 2 21.6 2 21V5C2 4.4 2.4 4 3 4H21C21.6 4 22 4.4 22 5V21C22 21.6 21.6 22 21 22Z" fill="black"/>
                            <path d="M12 12.4L7 17H17L12 12.4Z" fill="black"/>
                            <path opacity="0.3" d="M12 6V12.4L7 17H3V5C3 4.4 3.4 4 4 4H20C20.6 4 21 4.4 21 5V17H17L12 12.4V6Z" fill="black"/>
                          </svg>
                        </span>
                        {lang.labels.revertToDraft}
                      </div>
                    </button>
                  }
                  { providerInvoice.status === 'draft' && !(providerInvoice as any).id_source_company &&
                    <button className="btn btn-danger mb-1" type="button" onClick={submitProviderInvoiceDelete}>
                      <div className="d-flex align-items-center">
                        <span className="svg-icon svg-icon-2 ms-0">
                          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                            <path d="M5 9C5 8.44772 5.44772 8 6 8H18C18.5523 8 19 8.44772 19 9V18C19 19.6569 17.6569 21 16 21H8C6.34315 21 5 19.6569 5 18V9Z" fill="black" />
                            <path opacity="0.5" d="M5 5C5 4.44772 5.44772 4 6 4H18C18.5523 4 19 4.44772 19 5V5C19 5.55228 18.5523 6 18 6H6C5.44772 6 5 5.55228 5 5V5Z" fill="black" />
                            <path opacity="0.5" d="M9 4C9 3.44772 9.44772 3 10 3H14C14.5523 3 15 3.44772 15 4V4H9V4Z" fill="black" />
                          </svg>
                        </span>
                        {lang.labels.delete}
                      </div>
                    </button>
                  }
                </div>
              </div>
              <AppPurchaseViewDetail purchase={"invoice"} record={providerInvoice}></AppPurchaseViewDetail>
            </div>
            <AppPurchaseViewRequirements record={providerInvoice}></AppPurchaseViewRequirements>
            <div className="card card-flush mb-5">
              <div className="card-header">
                <div className="card-title">
                  <h4>{lang.labels.payments}</h4>
                </div>
                <div className="card-toolbar">
                  { providerInvoice.validated && providerInvoice.payment_status !== "fully-paid" &&
                    <button className="btn btn-sm btn-primary mb-1 me-2" type="button" onClick={executeShowModalPaymentCreateProviderInvoice}>
                      <div className="d-flex align-items-center">
                        <span className="svg-icon svg-icon-3 ms-0">
                          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path opacity="0.3" d="M3.20001 5.91897L16.9 3.01895C17.4 2.91895 18 3.219 18.1 3.819L19.2 9.01895L3.20001 5.91897Z" fill="black"/>
                            <path opacity="0.3" d="M13 13.9189C13 12.2189 14.3 10.9189 16 10.9189H21C21.6 10.9189 22 11.3189 22 11.9189V15.9189C22 16.5189 21.6 16.9189 21 16.9189H16C14.3 16.9189 13 15.6189 13 13.9189ZM16 12.4189C15.2 12.4189 14.5 13.1189 14.5 13.9189C14.5 14.7189 15.2 15.4189 16 15.4189C16.8 15.4189 17.5 14.7189 17.5 13.9189C17.5 13.1189 16.8 12.4189 16 12.4189Z" fill="black"/>
                            <path d="M13 13.9189C13 12.2189 14.3 10.9189 16 10.9189H21V7.91895C21 6.81895 20.1 5.91895 19 5.91895H3C2.4 5.91895 2 6.31895 2 6.91895V20.9189C2 21.5189 2.4 21.9189 3 21.9189H19C20.1 21.9189 21 21.0189 21 19.9189V16.9189H16C14.3 16.9189 13 15.6189 13 13.9189Z" fill="black"/>
                          </svg>
                        </span>
                        {lang.labels.makePayment}
                      </div>
                    </button>
                  }
                  { providerInvoice.validated && providerInvoice.payments.filter((p: any) => !p.is_deleted).length > 0 &&
                    <button className="btn btn-sm btn-primary mb-1" type="button" onClick={excuteViewOrHideButtonsToPaymentDelete}>
                      <div className="d-flex align-items-center">
                        <span className="svg-icon svg-icon-3 ms-0">
                          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path opacity="0.3" d="M8.38 22H21C21.2652 22 21.5196 21.8947 21.7071 21.7072C21.8946 21.5196 22 21.2652 22 21C22 20.7348 21.8946 20.4804 21.7071 20.2928C21.5196 20.1053 21.2652 20 21 20H10L8.38 22Z" fill="black"/>
                            <path d="M15.622 15.6219L9.855 21.3879C9.66117 21.582 9.43101 21.7359 9.17766 21.8409C8.92431 21.946 8.65275 22 8.37849 22C8.10424 22 7.83268 21.946 7.57933 21.8409C7.32598 21.7359 7.09582 21.582 6.90199 21.3879L2.612 17.098C2.41797 16.9042 2.26404 16.674 2.15903 16.4207C2.05401 16.1673 1.99997 15.8957 1.99997 15.6215C1.99997 15.3472 2.05401 15.0757 2.15903 14.8224C2.26404 14.569 2.41797 14.3388 2.612 14.145L8.37801 8.37805L15.622 15.6219Z" fill="black"/>
                            <path opacity="0.3" d="M8.37801 8.37805L14.145 2.61206C14.3388 2.41803 14.569 2.26408 14.8223 2.15906C15.0757 2.05404 15.3473 2 15.6215 2C15.8958 2 16.1673 2.05404 16.4207 2.15906C16.674 2.26408 16.9042 2.41803 17.098 2.61206L21.388 6.90198C21.582 7.0958 21.736 7.326 21.841 7.57935C21.946 7.83269 22 8.10429 22 8.37854C22 8.65279 21.946 8.92426 21.841 9.17761C21.736 9.43096 21.582 9.66116 21.388 9.85498L15.622 15.6219L8.37801 8.37805Z" fill="black"/>
                          </svg>
                        </span>
                        {removePayment ? lang.labels.doNotDeletePayments : lang.labels.deleteSomePayment}
                      </div>
                    </button>
                  }
                </div>
              </div>
              <div className="card-body pt-0">
                <div className="dataTables_wrapper">
                  <div className="table-responsive">
                    <table className="table align-middle table-row-dashed gy-2 mb-2">
                      <thead className="border-bottom">
                        <tr className="text-muted text-uppercase fw-bolder fs-7">
                          <th className="w-25px text-nowrap text-start">{lang.labels.n}</th>
                          <th className="min-w-100px text-nowrap text-start">{lang.labels.createdDate}</th>
                          <th className="min-w-100px text-nowrap text-start d-none">{lang.labels.method}</th>
                          <th className="min-w-100px text-nowrap text-start">{lang.labels.sourceOfIncome}</th>
                          <th className="min-w-100px text-nowrap text-end">{lang.labels.amount} ({providerInvoice.currency.code})</th>
                          { providerInvoice.validated && removePayment &&
                            <th className="w-75px text-nowrap text-end">{lang.labels.remove}</th>
                          }
                          </tr>
                      </thead>
                      { providerInvoice.payments.filter((p: any) => !p.is_deleted).length > 0
                        ?
                        <tbody className="text-secondary fw-bold">
                          { providerInvoice.payments.filter((p: any) => !p.is_deleted).map (( (item, index) => { return (
                            <tr key={index} className="row-dashed">
                              <td>{index + 1}</td>
                              <td>{dateFormat(lang.code, item.payment_date)}</td>
                              <td className="d-none">{paymentMethodValue(lang, item.method)}</td>
                              <td>{(item.method === 'credit-note') ? lang.labels.creditNote : treasuryAccountSelected(treasuryAccountsForCompany, item.source)}</td>
                              <td className="text-nowrap text-end">{formatMoney(item.amount)}</td>
                              { providerInvoice.validated && removePayment &&
                                <td valign="middle" className="text-end p-0">
                                  <button className="btn btn-sm btn-icon btn-flex btn-bg-transparent btn-active-color-danger h-30px w-30px" type="button" onClick={() => submitPaymentDelete(item.id)}>
                                    <span className="svg-icon svg-icon-primary svg-icon-3">
                                      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                        <path d="M5 9C5 8.44772 5.44772 8 6 8H18C18.5523 8 19 8.44772 19 9V18C19 19.6569 17.6569 21 16 21H8C6.34315 21 5 19.6569 5 18V9Z" fill="black" />
                                        <path opacity="0.5" d="M5 5C5 4.44772 5.44772 4 6 4H18C18.5523 4 19 4.44772 19 5V5C19 5.55228 18.5523 6 18 6H6C5.44772 6 5 5.55228 5 5V5Z" fill="black" />
                                        <path opacity="0.5" d="M9 4C9 3.44772 9.44772 3 10 3H14C14.5523 3 15 3.44772 15 4V4H9V4Z" fill="black" />
                                      </svg>
                                    </span>
                                  </button>
                                </td>
                                }
                            </tr>
                          )}))}
                        </tbody>
                        :
                        <tbody>
                          <tr className="text-secondary fw-bold">
                            <td colSpan={4} className="text-center">{lang.labels.thisInvoiceHasNoPayments}</td>
                          </tr>
                        </tbody>
                      }
                    </table>
                  </div>
                </div>
              </div>
            </div>
            <AppPurchaseViewAmount purchase={"invoice"} record={providerInvoice}></AppPurchaseViewAmount>
            <AppPurchaseViewVouchers purchase={"invoice"} record={providerInvoice} entity_type="provider-invoice" id_entity={providerInvoice?.id} id_company={companyForUser?.id} showVoucherActions={true} showDeleteAction={true} onVouchersChanged={() => { if (companyForUser && param.id) loadProviderInvoice(companyForUser.id, param.id) }}></AppPurchaseViewVouchers>
            <AppPurchaseViewSignatures record={providerInvoice}></AppPurchaseViewSignatures>
          </div>
          <AppPurchaseViewDraft record={providerInvoice} vouchers={vouchers} showGeneratedPdf={true} companyId={companyForUser?.id} pdfPath="provider-invoices" documentId={providerInvoice?.id} asideMinimize={asideMinimize} setAsideMinimize={setAsideMinimize}></AppPurchaseViewDraft>
        </div>
        :
        <AppPreloader></AppPreloader>
      }
      <AppModalProviderInvoiceUpdateValidate companyForUser={companyForUser} settingsForCompany={settingsForCompany} accountingAccountsForCompany={accountingAccountsForCompany} accountingTaxAccountsForCompany={accountingTaxAccountsForCompany} accountingExpenseAccountsForCompany={accountingExpenseAccountsForCompany} providerInvoice={providerInvoice} setProviderInvoice={setProviderInvoiceNormalized}></AppModalProviderInvoiceUpdateValidate>
      <AppModalProviderInvoiceUpdateValidate companyForUser={companyForUser} settingsForCompany={settingsForCompany} accountingAccountsForCompany={accountingAccountsForCompany} accountingTaxAccountsForCompany={accountingTaxAccountsForCompany} accountingExpenseAccountsForCompany={accountingExpenseAccountsForCompany} providerInvoice={providerInvoice} setProviderInvoice={setProviderInvoiceNormalized} mode="correction"></AppModalProviderInvoiceUpdateValidate>
      <AppModalProviderInvoiceUpdateInvalidate companyForUser={companyForUser} providerInvoice={providerInvoice} setProviderInvoice={setProviderInvoiceNormalized}></AppModalProviderInvoiceUpdateInvalidate>
      <AppModalPaymentCreateProviderInvoice companyForUser={companyForUser} settingsForCompany={settingsForCompany} accountingAccountsForCompany={accountingAccountsForCompany} treasuryAccountsForCompany={treasuryAccountsForCompany} accountingDebitEntriesForCompany={accountingDebitEntriesForCompany} providerInvoice={providerInvoice} setProviderInvoice={setProviderInvoiceNormalized} loadAccountingDebitEntriesForCompany={loadAccountingDebitEntriesForCompany}></AppModalPaymentCreateProviderInvoice>
      <AppModalProviderInvoiceStorageCenter companyForUser={companyForUser} storageCentersForCompany={storageCentersForCompany} providerInvoice={providerInvoice} setProviderInvoice={setProviderInvoiceNormalized}></AppModalProviderInvoiceStorageCenter>
      { companyForUser && providerInvoice &&
        <AppModalSendEmail companyId={companyForUser.id} documentType="provider-invoices" documentId={providerInvoice.id} documentNumber={providerInvoice.provider_invoice_number} recipientEmail={providerInvoice.provider?.data?.email || ''} companyName={companyForUser.name} companyEmail={companyForUser.email || ''}></AppModalSendEmail>
      }
    </div>
  )
}

export default ProviderInvoiceViewPage;
